import React from 'react';
import { Typography } from '@kp/react-ui';
import { useTranslation } from 'react-i18next';
import { createClasses } from '../../utils/css';
import { SelectItemRow } from '../../components/SelectItemRow';

const classes = createClasses({
  root: {
    height: '300px',
  },
  description: {
    marginTop: '24px',
  },
  input: {
    marginTop: '10px',
  },
});

interface SelectBuildingNameProps {
  buildingName: string;
  setBuildingName: (buildingName: string) => void;
}

export const SelectBuildingName: React.FC<SelectBuildingNameProps> = ({
  buildingName,
  setBuildingName,
}) => {
  const { t } = useTranslation();
  return (
    <div className={classes.root}>
      <Typography variant="headlineSmall" component="div">
        {t('select.buildingName.title')}
      </Typography>
      <Typography
        variant="bodyMedium"
        className={classes.description}
        component="div"
      >
        {t('select.buildingName.description')}
      </Typography>
      <div className={classes.input}>
        <SelectItemRow
          label={t('select.buildingName.label.buildingName')}
          value={buildingName}
          setValue={setBuildingName}
        />
      </div>
    </div>
  );
};
